export enum SelectListName {
  FREQUENCY = 'frequency',
  START_DATE_TYPE = 'start-date-type',
  DUE_START_DATE = 'due-start-date',
  STATE_OF_INCORPORATION = 'state-of-incorporation',
  ORGANISATIONS = 'organisations',
  SUBJECT = 'subject'
}
